import type { FC, SVGProps } from "react"
import React from "react"

import type { Point2d } from "@logic/lib/2d"

import { writePathPoint } from "~/utils/svg/writePathPoint"

type ArrowProps = {
  c: Point2d
  r: number
  h: number
  w: number
  weight: number
}

const DirectionIndicator_Internal: FC<ArrowProps> = ({ c, r, h, w, weight }) => {
  const props: Pick<
      SVGProps<SVGElement>,
      `fill` | `strokeLinecap` | `strokeWidth`
    > = {
      strokeWidth: weight,
      fill: `none`,
      strokeLinecap: `round`,
    },
    x00 = c.x - w / 2,
    x06 = c.x,
    x12 = c.x + w / 2,
    y00 = c.y - h / 2,
    y07 = c.y + h / 12,
    y12 = c.y + h / 2,
    d = [
      writePathPoint(x00, y07, `M`),
      writePathPoint(x06, y12, `L`),
      writePathPoint(x12, y07, `L`),
    ].join(`\n`)

  return (
    <g transform={`rotate(${r}, ${c.x}, ${c.y})`}>
      <g opacity={0.4}>
        <line
          stroke="#000f"
          x1={x06}
          y1={y00}
          x2={x06}
          y2={y12}
          {...props}
          strokeWidth={weight * 3}
        />
        <path stroke="#000f" d={d} {...props} strokeWidth={weight * 3} />
      </g>
      <line stroke="#ffff" x1={x06} y1={y00} x2={x06} y2={y12} {...props} />
      <path stroke="#ffff" d={d} {...props} />
    </g>
  )
}

export const DirectionIndicator = React.memo(DirectionIndicator_Internal)
